//eslint-disable-next-line
import axios, { $asyncGet, $asyncPost } from '../common.js';

/**
 * 店铺装修设置
 * v3/merchant/market/settings/Configure
 */
export function settingsConfigure(data) {
  return $asyncPost(`v3/merchant/market/settings/Configure?merchant_id=${localStorage.getItem("merchant_id")}`, data);
}
/**
 * 店铺装修设置
 * /v3/merchant/Market/settings/list
 */
export function getConfigure() {
  return $asyncGet(`v3/merchant/Market/settings/list?merchant_id=${localStorage.getItem("merchant_id")}`);
}

/*  */
/**
 * 登记客服
 * @param {} data {
 *  "agent_no": "02",
 *  "nick_name": "文文",
 *  "service_order": 1,
 *  "e_mail": "feel_zr@qq.com"
 *  }
 * @returns
 */
export function agenjtRegister(data) {
  return $asyncPost(`v3/merchant/customerservice/agent/Register?merchant_id=${localStorage.getItem("merchant_id")}&account_id=${data.account_id}`, data);
}

/**
 * 修改客服信息
 * @param {*} data
 * @returns
 */
export function agentUpdate(data) {
  return $asyncPost(`v3/merchant/customerservice/agent/update?merchant_id=${localStorage.getItem("merchant_id")}&agent_no=${data.agent_no}`, data);
}

/**
 * 获取店铺所有客服
 * v3/merchant/customerservice/agent/list
 */
export function agentList() {
  return $asyncGet(`v3/merchant/customerservice/agent/list?merchant_id=${localStorage.getItem("merchant_id")}`);
}

/**
 * v3/merchant/customerservice/agent/delete
 * 删除店铺客服
 * @param {String} agent_no 客服号
 * @returns
 */
export function agentDelete(agent_no) {
  return $asyncPost(`v3/merchant/customerservice/agent/delete?merchant_id=${localStorage.getItem("merchant_id")}&agent_no=${agent_no}`, {})
}

/**
 * v3/merchant/customerservice/agent/ListOnlineAgenet
 * 获取所有在线客服
 */
export function agentListOnlineAgenet() {
  return $asyncGet(`v3/merchant/customerservice/agent/ListOnlineAgenet?merchant_id=${localStorage.getItem("merchant_id")}`);
}